var en_US = {};
module['exports'] = en_US;
en_US.title = "United States (English)";
en_US.internet = require("./internet");
en_US.address = require("./address");
en_US.phone_number = require("./phone_number");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_US/index.js
// module id = 2183
// module chunks = 2